import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Collapse from '@material-ui/core/Collapse';
import CircularProgress from '@material-ui/core/CircularProgress';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import CancelIcon from '@material-ui/icons/Cancel';
import RefreshIcon from '@material-ui/icons/Refresh';
import { green, red } from '@material-ui/core/colors';
import moment from 'moment';
import { instanceAxios } from '../../InstanceAxios';
import { MSG_ERRO } from '../../consts/common';

const useStyles = makeStyles((theme) => ({
  vermelho: {
    color: theme.palette.getContrastText(red[500]),
    backgroundColor: red[500],
  },
  verde: {
    color: '#fff',
    backgroundColor: green[500],
  },
}));

function NotaTeste({ idEmpresa }) {
  const classes = useStyles();
  const [ready, setReady] = useState(false);
  const [nfe, setNfe] = useState([]);
  const [openAlert, setOpenAlert] = useState(false);
  const [tipoAlert, setTipoAlert] = useState('');
  const [msgAlert, setMsgAlert] = useState('');

  const atualizarNfe = async () => {
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`/nfeteste?idEmpresa=${idEmpresa}`)
      .then((res) => {
        setReady(true);
        setNfe(res.data);
      })
      .catch((err) => {
        setReady(true);
        setMsgAlert('Erro ao listar Nfes');
        setTipoAlert('error');
        setOpenAlert(true);
      });
  };

  const handleClick = (n) => {
    if (n.url_pdf) {
      window.open(n.url_pdf, '_blank');
    } else if (n.nfe_motivo_status) {
      setMsgAlert(n.nfe_motivo_status);
      setTipoAlert('info');
      setOpenAlert(true);
    } else {
      atualizarNfe();
    }
  };

  const emitirNfe = async () => {
    setReady(true);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .post(`/nfeteste`, {
        id_empresa: idEmpresa,
      })
      .then((res) => {
        setMsgAlert(
          'Nota Fiscal emitida com sucesso,espere a autorização da mesma'
        );
        setTipoAlert('success');
        setOpenAlert(true);
        atualizarNfe();
      })
      .catch((err) => {
        const msg = err.data ? err.data.message : MSG_ERRO;
        setMsgAlert(msg);
        setTipoAlert('error');
        setOpenAlert(true);
        setReady(true);
      });
  };

  const cancelNfe = async (nfe) => {
    console.log(nfe);
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .delete(`/nfeteste/${nfe.id}`)
      .then((res) => {
        setMsgAlert(
          'Cancelamento da nota solicitado,espere a autorização da mesma!'
        );
        setTipoAlert('success');
        setOpenAlert(true);
        atualizarNfe();
      })
      .catch((err) => {
        setMsgAlert(
          'Erro ao solicitar cancelamento nota fiscal,tente novamente!'
        );
        setTipoAlert('error');
        setOpenAlert(true);
        setReady(true);
      });
  };

  useEffect(() => {
    atualizarNfe();
  }, []);

  return (
    <>
      <Collapse in={!ready}>
        <CircularProgress style={{ marginLeft: '50%' }} />
      </Collapse>
      <Collapse in={ready}>
        <Grid container spacing={3} direction="row" justify="center">
          <h1>Notas Teste</h1>
        </Grid>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="space-between"
        >
          <Grid item>
            <List>
              {nfe.map((n) => (
                <ListItem button onClick={() => handleClick(n)}>
                  <ListItemAvatar>
                    <Avatar
                      className={
                        n.nfe_status === 'Autorizada'
                          ? classes.verde
                          : n.nfe_status === 'Negada' ||
                            n.nfe_status === 'Cancelada'
                          ? classes.vermelho
                          : ''
                      }
                    >
                      <InsertDriveFileIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={n.nfe_status}
                    secondary={moment(n.data_emissao).format('L')}
                  />
                  {n.nfe_status === 'Autorizada' ? (
                    <ListItemSecondaryAction>
                      <IconButton
                        edge="end"
                        aria-label="delete"
                        onClick={() => cancelNfe(n)}
                        color="secondary"
                      >
                        <CancelIcon />
                      </IconButton>
                    </ListItemSecondaryAction>
                  ) : null}
                </ListItem>
              ))}
            </List>
          </Grid>
          <Grid item>
            <IconButton
              color="primary"
              aria-label="add an alarm"
              onClick={atualizarNfe}
            >
              <RefreshIcon />
            </IconButton>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={3}
          direction="row"
          justify="center"
          alignItems="flex-end"
        >
          <Button variant="contained" color="primary" onClick={emitirNfe}>
            Emitir Nfe Teste
          </Button>
        </Grid>
      </Collapse>
      <Snackbar
        open={openAlert}
        autoHideDuration={6000}
        onClose={() => setOpenAlert(!openAlert)}
      >
        <Alert severity={tipoAlert} onClick={() => setOpenAlert(!openAlert)}>
          {msgAlert}
        </Alert>
      </Snackbar>
    </>
  );
}

export default NotaTeste;
